function extendValidationSettings(settings) {
  var extended = $.extend(
    {},
    {
      highlight: function (element, label) {
        var group = $(element).closest('.form-group');
        group.addClass('error').removeClass('noError');
        $(element).addClass('error').removeClass('noError');
        group.find('[id^=s2id]').addClass('error');
      },
      unhighlight: function (element, label) {
        var group = $(element).closest('.form-group');
        group.addClass('noError').removeClass('error');
        $(element).addClass('noError').removeClass('error');
        group.find('[id^=s2id]').addClass('noError').removeClass('error');
      },
      success: function (element, label) {
        var group = $(element).closest('.form-group');
        if (group.find('.error').length === 0) {
          group.removeClass('error');
        }
      },
      errorContainer: '#errorMessageBox',
      errorLabelContainer: '#errorList',
      errorElement: 'li',
      onkeyup: false,
      ignore: '',
    },
    settings
  );

  return extended;
}

function registerPopovers() {
  //Show popover tooltips
  $('.popoverHelp').popover({
    title: '<i class="fa fa-question"></i>&nbsp; Help',
  });

  // Accessibility: Allow Escape key to dismiss open popovers (WCAG 1.4.13)
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $('.popoverHelp').popover('hide');
    }
  });
}

function initSessionCountdown() {
  if ($('#sessionTimeRemaining').length > 0) {
    setInterval(function () {
      var secondsRemaining = $('#sessionTimeRemaining').data('secondsRemaining') - 1;

      if (secondsRemaining <= 0) {
        window.location = '/CancelCheckIn';
      }

      $('#sessionTimeRemaining').data('secondsRemaining', secondsRemaining);

      $('#sessionTimeRemaining').text(mmss(secondsRemaining));
    }, 1000);
  }
}

function mmss(secs) {
  var minutes = Math.floor(secs / 60);
  secs = secs % 60;
  var hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return pad(minutes) + ':' + pad(secs);
}

function pad(num) {
  return ('0' + num).slice(-2);
}

$(function ($) {
  initSessionCountdown();
  registerPopovers();

  // Accessibility: Mark Font Awesome icons as decorative for screen readers
  $('i.fa').not('[aria-hidden]').attr('aria-hidden', 'true');

  // Accessibility: Modal focus trap and restore (WCAG 2.1.2, 2.4.3)
  $('.modal').on('show.bs.modal', function () {
    $(this).data('previousFocus', document.activeElement);
  });

  $('.modal').on('shown.bs.modal', function () {
    var focusTarget = $(this).find('[autofocus]');
    if (!focusTarget.length) {
      focusTarget = $(this).find('input:visible, select:visible, textarea:visible, button:visible, a[href]:visible').first();
    }
    if (focusTarget.length) {
      focusTarget.focus();
    } else {
      $(this).focus();
    }
  });

  // Trap focus within open modal (WCAG 2.1.2)
  $(document).on('keydown', '.modal.in', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = $(this)
      .find('input:visible, select:visible, textarea:visible, button:visible, a[href]:visible, [tabindex]:visible')
      .not('[tabindex="-1"]');
    if (!focusable.length) return;
    var first = focusable.first()[0];
    var last = focusable.last()[0];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Restore focus when modal closes (WCAG 2.4.3)
  $('.modal').on('hidden.bs.modal', function () {
    var previousFocus = $(this).data('previousFocus');
    if (previousFocus && $(previousFocus).is(':visible')) {
      previousFocus.focus();
    }
  });
});

//High Contrast Mode
$('#highContrastToggle').click(function () {
  var highContrastCookie = Cookies.get('HighContrast');

  if (highContrastCookie == null) {
    Cookies.set('HighContrast', 'On');
    window.location.reload();
  } else if (highContrastCookie == 'On') {
    Cookies.set('HighContrast', 'Off');
    window.location.reload();
  } else if (highContrastCookie == 'Off') {
    Cookies.set('HighContrast', 'On');
    window.location.reload();
  }
});
